<template>
  <div class="show-box">
    <div v-if="option" :class="'style_' + option.index" class="tag">
      {{ option.name }}
    </div>
  </div>
</template>
<script lang="ts" setup>
import {computed, defineProps} from 'vue';
import {SelectFieldType} from '@/components/business/crud/interface/FieldType';
import {WidgetInfo} from "@/components/business/crud/widgets/WidgetContainer";
import { ColumnEdit } from '@/components/business/crud/widgets/TableWidgetContainer';

const props = defineProps<{
  columnEdit?: ColumnEdit;
  propName: string;
  widget: SelectFieldType;
  info: WidgetInfo;
  data: any;
}>();

const option = computed(() => {
  for (const index in props.widget.options) {
    const option = props.widget.options[index];
    if (option.value === props.data[props.propName]) {
      return {
        index: Number(index) % 6,
        name: option.name,
      };
    }
  }
  return undefined;
})

</script>

<style lang="scss" scoped>
.show-box {
  height: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: $font-size-small;

  .tag {
    color: #fff;
    font-size: $font-size-small;
    font-weight: $font-weight-primary;
    border-radius: $border-radius-medium;
    padding: 1px 3px;

    &.style_0 {
      background: $color-primary;
    }

    &.style_1 {
      background: $color-success;
    }

    &.style_2 {
      background: $color-warning;
    }

    &.style_3 {
      background: $color-danger;
    }

    &.style_4 {
      background: $color-info;
    }

    &.style_5 {
      background: $color-theme-bg;
    }
  }
}
</style>
